// Penn's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from the official Penn
// Undergraduate Catalog 2026-27 (catalog.upenn.edu/undergraduate/), one page
// per undergraduate school: Arts and Sciences Majors, Engineering and Applied
// Science Majors, Wharton Concentrations, Nursing Majors. Every line ending in
// a degree (BA, BSE, BAS, BS, BSN); the concentrations and tracks listed under
// a major are left out, as are minors and the SEAS second-major options open
// only to College students. Wharton students all earn the BS in Economics and
// choose a concentration, so its group lists concentrations. The coordinated
// dual-degree programs (Huntsman, M&T, LSM and others) are not in these four
// lists and are left out. No flags: the college file holds no programs source.
// The KB list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-pennsylvania",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in Penn's official Undergraduate Catalog, grouped by the four undergraduate schools, with the degree it leads to; Wharton lists the concentrations within its BS in Economics. Minors, tracks and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Arts and Sciences",
            "source": {
                "label": "Penn Undergraduate Catalog, School of Arts & Sciences, Majors",
                "url": "https://catalog.upenn.edu/undergraduate/arts-sciences/majors/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ancient History",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biophysics",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Design",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Environmental Science",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Languages and Civilizations",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BA"
                },
                {
                    "name": "Francophone, Italian and Germanic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender, Sexuality, & Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Health and Societies",
                    "degree": "BA"
                },
                {
                    "name": "Hispanic Studies",
                    "degree": "BA"
                },
                {
                    "name": "History of Art",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Individualized Major",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American & Latinx Studies",
                    "degree": "BA"
                },
                {
                    "name": "Law and Society",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Logic, Information, & Computation",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern Languages & Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Modern Middle Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian and East European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "South Asia Studies",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                },
                {
                    "name": "Visual Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Engineering and Applied Science",
            "source": {
                "label": "Penn Undergraduate Catalog, School of Engineering and Applied Science, Majors",
                "url": "https://catalog.upenn.edu/undergraduate/engineering-applied-science/majors/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BSE"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BSE"
                },
                {
                    "name": "Biomedical Science",
                    "degree": "BAS"
                },
                {
                    "name": "Chemical and Biomolecular Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BAS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSE"
                },
                {
                    "name": "Digital Media Design",
                    "degree": "BSE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering and Applied Mechanics",
                    "degree": "BSE"
                },
                {
                    "name": "Visual and Interactive Computing",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "The Wharton School",
            "source": {
                "label": "Penn Undergraduate Catalog, The Wharton School, Concentrations",
                "url": "https://catalog.upenn.edu/undergraduate/wharton/concentrations/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence for Business",
                    "degree": "BS"
                },
                {
                    "name": "Behavioral Economics",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Business Economics and Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Health Care Management and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Impact, Value and Sustainable Business",
                    "degree": "BS"
                },
                {
                    "name": "Individualized",
                    "degree": "BS"
                },
                {
                    "name": "Leading Across Differences",
                    "degree": "BS"
                },
                {
                    "name": "Legal Studies & Business Ethics",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing & Communication",
                    "degree": "BS"
                },
                {
                    "name": "Marketing & Operations Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Operations, Information & Decisions",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                },
                {
                    "name": "Retailing",
                    "degree": "BS"
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Penn Undergraduate Catalog, School of Nursing, Majors",
                "url": "https://catalog.upenn.edu/undergraduate/nursing/majors/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BSN"
                }
            ]
        }
    ]
};

export default majors;
